import { Icon } from '@assembly-js/design-system';
import clsx from 'clsx';
import React, { useContext } from 'react';

import { WorkspaceAvatar } from 'src/components/WorkspaceAvatar/WorkspaceAvatar';
import { SidebarThemeContext } from 'src/context/sidebarThemeContext';

interface SidebarSwitcherButtonProps {
  iconSrc?: string;
  iconFallbackColor?: string;
  name: string;
  isOpen: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SidebarSwitcherButton = React.forwardRef<
  HTMLButtonElement,
  SidebarSwitcherButtonProps
>(({ iconSrc, iconFallbackColor, name, isOpen, onClick }, ref) => {
  const { sidebarTextColor, sidebarItemHoverBackground } =
    useContext(SidebarThemeContext);

  return (
    <button
      ref={ref}
      type="button"
      aria-expanded={isOpen}
      onClick={onClick}
      style={
        {
          '--sidebar-item-hover-bg': sidebarItemHoverBackground,
        } as React.CSSProperties
      }
      className={clsx(
        'w-full h-9 flex items-center justify-start px-2 py-1 rounded border-none cursor-pointer',
        'hover:bg-[var(--sidebar-item-hover-bg)] active:bg-[var(--sidebar-item-hover-bg)]',
        'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-info-text',
        isOpen ? 'bg-[var(--sidebar-item-hover-bg)]' : 'bg-transparent',
      )}
    >
      <WorkspaceAvatar
        iconSrc={iconSrc ?? null}
        workspaceName={name}
        size={25}
        containerClassName="mr-2"
        fallbackBackgroundColor={iconFallbackColor}
      />
      <span
        className="truncate text-[13px] font-medium"
        style={{ color: sidebarTextColor }}
      >
        {name}
      </span>
      <Icon
        icon={isOpen ? 'ChevronUp' : 'ChevronDown'}
        className="ml-[6px] w-3 h-3 shrink-0"
        style={{ color: sidebarTextColor }}
      />
    </button>
  );
});

SidebarSwitcherButton.displayName = 'SidebarSwitcherButton';
